module.exports = __webpack_public_path__ + "img/3.34eaacd9.png";